export var TITLE = 'Grok';
export var TEXT_MULTIPLE = 0.75;
export var SPACE_MULTIPLE = 0.25;
export var COLOR_PRIMARY = '#fff';